import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUserSlash, IconDefinition } from '@fortawesome/pro-solid-svg-icons';

@Component({
    selector: 'fdx-non-system-user-avatar',
    templateUrl: './non-system-user-avatar.component.html',
    styleUrls: ['../user-avatar.scss', './non-system-user-avatar.component.scss'],
    standalone: true,
    imports: [
        FontAwesomeModule
    ]
})
export class NonSystemUserAvatarComponent {
    @Input() hasNotifications: boolean = false;
    readonly nonUserIcon: IconDefinition = faUserSlash;
}
